import { Reveal } from '@/components/ui/Reveal'

import { SectionLabel } from './HowItWorks'

const turfs = [
  {
    loc: 'Andheri West, Mumbai',
    name: 'Champions Arena',
    pitchColor: '#142919',
    price: 800,
    sport: '⚽ Football · 5v5',
    stars: 5,
    svgPath: (
      <path
        d="M12 8h276v124H12z M150 8v124 M150 70m-28 0a28 28 0 1 0 56 0a28 28 0 1 0-56 0 M12 45h28v50H12 M260 45h28v50H260"
        fill="none"
        stroke="#b8ec3c"
        strokeWidth="1.5"
      />
    ),
  },
  {
    loc: 'Gachibowli, Hyderabad',
    name: 'StrikerZone',
    pitchColor: '#11201a',
    price: 1500,
    sport: '🏏 Box Cricket',
    stars: 5,
    svgPath: (
      <path
        d="M12 8h276v124H12z M150 70m-55 0a55 55 0 1 0 110 0a55 55 0 1 0-110 0 M12 70h276 M120 8h60v30H120 M120 102h60v30H120"
        fill="none"
        stroke="#b8ec3c"
        strokeWidth="1.5"
      />
    ),
  },
  {
    loc: 'Anna Nagar, Chennai',
    name: 'Shuttle Palace',
    pitchColor: '#0f1f17',
    price: 400,
    sport: '🏸 Badminton · Indoor',
    stars: 4,
    svgPath: (
      <path
        d="M20 20h120v100H20z M160 20h120v100H160z M20 70h260"
        fill="none"
        stroke="#b8ec3c"
        strokeDasharray="6 4"
        strokeWidth="1.5"
      />
    ),
  },
]

export function FeaturedTurfs() {
  return (
    <section
      className="py-20"
      id="turfs"
      style={{
        background: 'var(--bg2)',
        borderBottom: '1px solid var(--lime-line)',
        borderTop: '1px solid var(--lime-line)',
      }}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <SectionLabel>Featured turfs</SectionLabel>
        <Reveal delay={0.05}>
          <h2
            className="font-display font-bold leading-[1.1] tracking-tight mb-12"
            style={{
              color: 'var(--text)',
              fontSize: 'clamp(1.9rem,3.5vw,2.8rem)',
              letterSpacing: '-.5px',
              maxWidth: 520,
            }}
          >
            Top-rated venues near you
          </h2>
        </Reveal>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {turfs.map((t, i) => (
            <Reveal delay={i * 0.09} key={t.name}>
              <div
                className="rounded-2xl overflow-hidden transition-all duration-200 hover:-translate-y-1"
                onMouseEnter={(e) => (e.currentTarget.style.borderColor = 'rgba(184,236,60,.4)')}
                onMouseLeave={(e) => (e.currentTarget.style.borderColor = 'var(--lime-line)')}
                style={{ background: 'var(--bg3)', border: '1px solid var(--lime-line)' }}
              >
                {/* Pitch visual */}
                <div
                  className="h-35 flex items-center justify-center relative"
                  style={{ background: t.pitchColor }}
                >
                  <svg className="w-[85%] h-full opacity-15" viewBox="0 0 300 140">
                    {t.svgPath}
                  </svg>
                  <span
                    className="absolute top-3 left-3 text-[0.65rem] font-bold px-3 py-1 rounded-full"
                    style={{
                      background: 'rgba(11,28,16,.85)',
                      border: '1px solid var(--lime-line)',
                      color: 'var(--lime)',
                    }}
                  >
                    {t.sport}
                  </span>
                </div>

                <div className="p-5">
                  <div
                    className="flex gap-0.5 mb-1.5 text-[0.7rem]"
                    style={{ color: 'var(--lime)' }}
                  >
                    {'★'.repeat(t.stars)}
                    {'☆'.repeat(5 - t.stars)}
                  </div>
                  <div
                    className="font-display font-semibold text-[1rem] mb-1"
                    style={{ color: 'var(--text)' }}
                  >
                    {t.name}
                  </div>
                  <div className="text-[0.75rem] mb-4" style={{ color: 'var(--muted)' }}>
                    📍 {t.loc}
                  </div>
                  <div className="flex items-center justify-between">
                    <div
                      className="font-display font-bold text-[1.15rem]"
                      style={{ color: 'var(--lime)' }}
                    >
                      ₹{t.price.toLocaleString('en-IN')}{' '}
                      <span
                        className="text-[0.68rem] font-normal font-body"
                        style={{ color: 'var(--muted)' }}
                      >
                        / hr
                      </span>
                    </div>
                    <a
                      className="text-[0.75rem] font-bold px-4 py-1.5 rounded-full border transition-all duration-150 inline-block"
                      href="/turfs"
                      onMouseEnter={(e) => {
                        e.currentTarget.style.background = 'var(--lime)'
                        e.currentTarget.style.color = 'var(--bg)'
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.background = 'var(--lime-dim)'
                        e.currentTarget.style.color = 'var(--lime)'
                      }}
                      style={{
                        background: 'var(--lime-dim)',
                        borderColor: 'var(--lime-line)',
                        color: 'var(--lime)',
                      }}
                    >
                      Book Now
                    </a>
                  </div>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  )
}
